document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  const section = document.querySelector(".ask-anything-section");
  if (!section) return;

  const title = section.querySelector("h2");
  const subtitle = section.querySelector(".subtitle");
  const bubbleTexts = section.querySelectorAll(".features--bubblees .bubble-text");
  const compactItems = section.querySelectorAll(".features--compact li");
  const button = section.querySelector(".ask-anything-section__review-link");
  const deviceImage = section.querySelector(".device-image");

  if (title) {
    gsap.fromTo(title, { y: 30, opacity: 0 }, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: title,
        start: "top 85%",
        toggleActions: "play reverse play reverse",
      }
    });
  }

  if (subtitle) {
    gsap.fromTo(subtitle, { y: 30, opacity: 0 }, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: subtitle,
        start: "top 85%",
        toggleActions: "play reverse play reverse",
      }
    });
  }

  bubbleTexts.forEach((item) => {
    gsap.fromTo(item, { y: 30, opacity: 0 }, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: item,
        start: "top 85%",
        toggleActions: "play reverse play reverse",
      }
    });
  });

  compactItems.forEach((item) => {
    gsap.fromTo(item, { y: 30, opacity: 0 }, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: item,
        start: "top 85%",
        toggleActions: "play reverse play reverse",
      }
    });
  });

  if (button) {
    gsap.fromTo(button, { y: 30, opacity: 0 }, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power2.out",
      scrollTrigger: {
        trigger: button,
        start: "top 85%",
        toggleActions: "play reverse play reverse",
      }
    });
  }

  if (deviceImage) {
    gsap.fromTo(deviceImage, { y: 40, opacity: 0 }, {
      y: 0,
      opacity: 1,
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: deviceImage,
        start: "top 85%",
        toggleActions: "play reverse play reverse",
      }
    });
  }

  ScrollTrigger.refresh();
});
